/* =========================================
   Helen Anthony – Size Guide Drawer (JS)
   Fully scoped, no globals exposed.
   ========================================= */

(function () {
  function initSizeGuideDrawer() {
    var triggers = document.querySelectorAll('[data-size-guide-trigger]');
    var drawer = document.querySelector('[data-size-guide-drawer]');
    var overlay = document.querySelector('[data-size-guide-overlay]');
    var closeButtons = document.querySelectorAll('[data-size-guide-close]');
    var accordionToggle = document.querySelector('[data-size-guide-accordion-toggle]');
    var accordionPanel = document.querySelector('[data-size-guide-accordion-panel]');
    var tables = document.querySelectorAll('[data-size-table]');
    var tabs = document.querySelectorAll('[data-size-tab]');

    if (!drawer || !overlay || !triggers.length) {
      return; // not on this page
    }

    var activeTab = 'beaded'; // default tab

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('size-guide-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-guide-open');
    }

    function updateTables() {
      tables.forEach(function (wrapper) {
        var tabValue = wrapper.getAttribute('data-size-tab-value');
        wrapper.classList.toggle('is-active', tabValue === activeTab);
      });
    }

    // -----------------------------
    // Triggers – open drawer
    // -----------------------------
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer();
      });
    });

    // -----------------------------
    // Close on overlay and buttons
    // -----------------------------
    overlay.addEventListener('click', closeDrawer);

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        closeDrawer();
      });
    });

    // Close on ESC
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        }
      }
    });

    // -----------------------------
    // Accordion: How to measure
    // -----------------------------
    if (accordionToggle && accordionPanel) {
      accordionToggle.addEventListener('click', function () {
        var isOpen = accordionToggle.classList.contains('is-open');
        accordionToggle.classList.toggle('is-open', !isOpen);
        accordionToggle.setAttribute('aria-expanded', String(!isOpen));
        accordionPanel.hidden = isOpen;
      });
    }

    // -----------------------------
    // Tabs: Beaded / Plain
    // -----------------------------
    if (tabs.length && tables.length) {
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var tabName = tab.getAttribute('data-size-tab');
          if (!tabName || tabName === activeTab) return;

          activeTab = tabName;

          tabs.forEach(function (t) {
            t.classList.toggle('is-active', t === tab);
          });

          updateTables();
        });
      });

      // Initial state
      updateTables();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideDrawer);
  } else {
    initSizeGuideDrawer();
  }
})();
